import React, { useState, useEffect } from "react";
import './sciqusheader.scss'
import sciquslogo from '../../assest/newlogo.png'

const SciqusHeader = () => {
	const [sticky, setSticky] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);
	
	useEffect(() => {
		const handleScroll = () => {
			setSticky(window.scrollY > 50);
		};
		
		window.addEventListener("scroll", handleScroll);
		
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);
	
	return (
		<header className={`header ${sticky ? "sticky" : ""}`}>
			<div className="logo"><img src={sciquslogo} alt=""/></div>
			
			<div
				className={`hamburger ${menuOpen ? "active" : ""}`}
				onClick={() => setMenuOpen(!menuOpen)}
			>
				<span></span>
				<span></span>
				<span></span>
			</div>
			
			<nav className={menuOpen ? "open" : ""}>
				<a href="#revora">About</a>
				<a href="#whatams">SciqusAMS</a>
				<a href="#customer360+">Customer 360+</a>
				<a href="#endtoendaccountmanagementplatform">Account Platform</a>
				<a href="#benefits">Benefits</a>
				<a href="#services">Services</a>
				<a href="#amsimplementationprocess">AMS Implementation Process</a>
				<a href="#whyus">Why Us</a>
				<a href="#contact">Contact Us</a>
			</nav>
		</header>
	);
};

export default SciqusHeader;